import { render, staticRenderFns } from "./TextareaItem.vue?vue&type=template&id=3361ac3a&scoped=true&"
import script from "./TextareaItem.vue?vue&type=script&lang=js&"
export * from "./TextareaItem.vue?vue&type=script&lang=js&"
import style0 from "./TextareaItem.vue?vue&type=style&index=0&id=3361ac3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3361ac3a",
  null
  
)

export default component.exports